import { useRouter } from 'next/router'
import { GlobalTextSize } from '~/@types/text-size'
import mapSliceToComponent from '~/imports/product_page'
import { SHOPIFY_TYPES } from '~/lib/shopify/constants'

import { ProductData } from '@unlikelystudio/react-abstract-components'

import ProductsGrid from '~/components/Slices/ProductsGrid'
import ProductHeader from '~/components/UI/ProductHeader'
import SliceManager from '~/components/UI/SliceManager'

import { ClientPageView } from '~/providers/GTMTrackingProvider/ClientPageView'
import ProductZoomProvider from '~/providers/ProductZoomProvider'
import ShopifyProductProvider from '~/providers/ShopifyProductProvider'

import useCurrency from '~/hooks/useCurrency'

import serializeJSONLD from '~/data/json-ld/product/serialize-json-ld'
import getProductPageStaticPropsFunction from '~/data/product-page-data'
import { ProductPageData } from '~/data/product-page-data/serializer'

import css from './styles.module.scss'

export default function ProductFashion({
  slices,
  currentProduct,
  productHeader,
  productRecommandations,
}: ProductPageData) {
  const router = useRouter()
  const currency = useCurrency()

  return (
    <>
      <ProductData
        {...serializeJSONLD({
          name: productHeader?.name ?? null,
          description: productHeader?.jsonLD?.description ?? null,
          images: productHeader?.images ?? null,
          variants: productHeader?.variants ?? null,
          path: router?.asPath?.split('?')?.[0] ?? null,
          currency,
          sku: productHeader?.jsonLD?.sku ?? null,
          mpn: productHeader?.jsonLD?.barcode ?? null,
        })}
      />

      <ShopifyProductProvider
        uid={currentProduct?.uid}
        type={productHeader?.type}
        id={productHeader?.shopifyId}>
        <ProductZoomProvider medias={productHeader?.medias}>
          <ProductHeader className={css.productHeader} {...productHeader} />
        </ProductZoomProvider>
      </ShopifyProductProvider>
      <SliceManager
        mapSliceTypeToComponent={mapSliceToComponent}
        slicesData={slices}
        customStartPosition={2}
      />
      <ProductsGrid
        {...productRecommandations}
        layout={GlobalTextSize.Medium}
      />
      <ClientPageView template="product" />
    </>
  )
}

export const getStaticProps = getProductPageStaticPropsFunction(
  SHOPIFY_TYPES.PRODUCT_FASHION,
)

export { getStaticPaths } from '~/data/product-page-data/get-static-paths'
